<template>
  <l-modal
    v-if="!isMobile"
    v-model:open="open"
    :title="t('checkout.custom-amount')"
    :description="description"
    :button-text="t('checkout.confirm-amount')"
    :secondary-button-text="t('ctas.cancel')"
    :secondary-button="true"
    :backdrop-closable="true"
    @secondary-action="open = false"
    @action="$emit('newAmount', amount)"
    @close="open = false"
  >
    <div class="sm:h-80">
      <calculator
        display-mode="toPay"
        :keypad-mode="keypadMode || 'full'"
        :max-value="maxValue"
        :initial-to-pay="defaultAmount"
        :reset-on-first-input="true"
        @change="payload => (amount = payload.toPay)"
      />
    </div>
  </l-modal>
  <drawer v-else v-model="open">
    <div class="flex flex-col w-full px-4 pb-4">
      <div class="body-1 text-n-200">{{ t('checkout.custom-amount') }}</div>
      <div class="body-3 mb-6">{{ description }}</div>
      <div class="h-80 shrink-0">
        <calculator
          display-mode="toPay"
          :keypad-mode="keypadMode || 'full'"
          :max-value="maxValue"
          :initial-to-pay="defaultAmount"
          :reset-on-first-input="true"
          @change="payload => (amount = payload.toPay)"
        />
      </div>
      <div class="flex gap-2 mt-4">
        <l-button class="w-full" type="secondary" @click="open = false">
          {{ t('ctas.cancel') }}
        </l-button>
        <l-button class="w-full" type="primary" @click="$emit('newAmount', amount)">
          {{ t('checkout.confirm-amount') }}
        </l-button>
      </div>
    </div>
  </drawer>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { LButton, LModal } from '@last/core-ui/paprika'

import Calculator from '@/components/Calculator/Calculator.vue'
import type { CalculatorKeypadModeType } from '@/components/Calculator/types'
import Drawer from '@/components/Drawer.vue'
import { isMobile } from '@/utils/device-type'

withDefaults(
  defineProps<{
    defaultAmount: number
    maxValue?: number
    description: string
    keypadMode?: CalculatorKeypadModeType
  }>(),
  {
    maxValue: undefined,
    keypadMode: 'full'
  }
)

defineEmits<{
  newAmount: [number]
}>()

const open = defineModel<boolean>('open', {
  default: false
})

const { t } = useI18n()

const amount = ref<number>(0)
</script>
